import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyALPQZp6y61e7jWKaxnjhnpU0M97aj-Ks0",
  authDomain: "familytopup-f53e0.firebaseapp.com",
  projectId: "familytopup-f53e0",
  storageBucket: "familytopup-f53e0.firebasestorage.app",
  messagingSenderId: "353466175655",
  appId: "1:353466175655:web:6f811e8e26b54048dd4b82"
};

initializeApp(firebaseConfig);